@for (child of items | dsl | async; track trackByProp($index, child)) {
    <ng-container *vnDynamicComponent="getItemComponent(child.type); attr: { item: child }" />
}
